import React, { useEffect, useState } from "react";
import { getStoreSettings } from "../services/api";
import { useApp } from "../context/AppContext";
import { WaitlistDialog } from "./WaitlistDialog";
import { BellRing, PackageX, X } from "lucide-react";

export const SoldOutBanner = () => {
  const { lang } = useApp();
  const [soldOut, setSoldOut] = useState(false);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("moc_soldout_dismissed") === "1");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getStoreSettings().then((s) => setSoldOut(!!s.sold_out)).catch(() => {});
  }, []);

  if (!soldOut || dismissed) return null;
  const de = lang !== "en";

  return (
    <>
      <div className="fixed top-20 inset-x-0 z-40 bg-wine text-cream shadow-lg" data-testid="soldout-banner">
        <div className="max-w-7xl mx-auto px-4 py-2.5 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-center">
          <p className="text-sm flex items-center gap-2">
            <PackageX className="w-4 h-4 text-gold shrink-0" />
            {de
              ? "Momentan ausverkauft — unser Lieferant kann zurzeit leider nicht liefern."
              : "Currently sold out — our supplier is temporarily unable to deliver."}
          </p>
          <button
            data-testid="soldout-banner-notify-btn"
            onClick={() => setOpen(true)}
            className="inline-flex items-center gap-1.5 bg-gold text-ink text-xs font-semibold uppercase tracking-wide rounded-full px-4 py-1.5 hover:bg-cream transition-colors"
          >
            <BellRing className="w-3.5 h-3.5" /> {de ? "Benachrichtigen lassen" : "Notify me"}
          </button>
        </div>
        <button
          data-testid="soldout-banner-close"
          aria-label="Schliessen"
          onClick={() => { setDismissed(true); sessionStorage.setItem("moc_soldout_dismissed", "1"); }}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-cream/60 hover:text-cream"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
      <WaitlistDialog open={open} onOpenChange={setOpen} lang={lang} />
    </>
  );
};

export default SoldOutBanner;
